const { STATUS } = require("../../components/constants/statuses");

const FilterComponent = ({ statusFilter, setStatusFilter }) => {
  const tabs = {
    All: "",
    Paid: STATUS.PAID,
    Pending: STATUS.PENDING,
    Approved: STATUS.APPROVED,
    Played: STATUS.PLAYED,
    Rejected: STATUS.REJECTED,
  };

  return (
    <div className="flex space-x-4 overflow-x-auto mb-6 w-full no-scrollbar">
      {Object.entries(tabs).map(([label, value]) => (
        <button
          key={label}
          onClick={() => setStatusFilter(value)}
          className={`flex-shrink-0 px-4 py-2 rounded-full transition font-semibold max-w-full ${
            statusFilter === value
              ? "bg-accent text-black"
              : "bg-secondary hover:bg-opacity-80"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default FilterComponent;
